module.exports = __webpack_public_path__ + "bagr.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/bagr.jpg
// module id = 29
// module chunks = 0